import React from 'react'
import Skeletons from '@/custom/components/Skeletons'
import './Loader.css'

function BannerSkeletons() {
    return (
        <div className="bannerSkeletonWrapper">
            <div className="bannerSkeleton">
                <Skeletons type="bannerImage" />
            </div>
        </div>
    )
}

export default BannerSkeletons
